import { render, staticRenderFns } from "./CalculatorSlider.vue?vue&type=template&id=580e5ab8&scoped=true"
import script from "./CalculatorSlider.vue?vue&type=script&lang=ts"
export * from "./CalculatorSlider.vue?vue&type=script&lang=ts"
import style0 from "./CalculatorSlider.vue?vue&type=style&index=0&id=580e5ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e5ab8",
  null
  
)

export default component.exports